import * as Sentry from "@sentry/nuxt";
import useTenant from "~/composables/Tenant/common/useTenant";

export default defineNuxtPlugin(() => {
  const runtimeConfigs = useRuntimeConfig();
  const { tenant } = useTenant();

  const tenantPath =
    runtimeConfigs.public.VERSION == "PREVIEW" && tenant.value
      ? tenant.value.url
      : runtimeConfigs.public.CMS_URL;
  const SENTRY_DSN = runtimeConfigs.public.SENTRY_VUE_DSN;
  const ENV = runtimeConfigs.public.ENVIRONMENT;

  const router = useRouter();

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.httpContextIntegration(),
      Sentry.browserApiErrorsIntegration({
        setTimeout: true,
        setInterval: true,
        requestAnimationFrame: true,
        XMLHttpRequest: true,
        eventTarget: true,
      }),
    ],

    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.01,
    beforeSend(event, hint) {
      if (event.exception) {
        console.error(
          `[Exception handled by Sentry]: (${hint.originalException})`,
          { event, hint },
        );
        event.extra = {
          //@ts-expect-error
          originalException: JSON.stringify(hint.originalException?.data ?? {}),
        };
      }

      //@ts-expect-error
      if (hint.originalException?.name !== "FetchError") return event;
      return null;
    },
  });

  Sentry.setTag("tenant", tenantPath);
});
